import React, { ReactNode, useEffect, useRef } from "react";
import { gsap } from "gsap";
import { IoIosClose } from "react-icons/io";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  className?: string;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  className = "",
}) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const backgroundRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen) {
      gsap.fromTo(
        modalRef.current,
        { opacity: 0, y: 50 },
        { opacity: 1, y: 0, duration: 0.5, ease: "power3.out" }
      );
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) {
      gsap.to(modalRef.current, {
        opacity: 0,
        y: 50,
        duration: 0.5,
        ease: "power3.in",
        onComplete: () => {
          onClose();
        },
      });
    }
  }, [isOpen, onClose]);

  const handleBackgroundClick = (e: React.MouseEvent) => {
    if (e.target === backgroundRef.current) {
      onClose();
    }
  };

  return isOpen ? (
    <div
      className={`modal-base ${className}`}
      ref={backgroundRef}
      onClick={handleBackgroundClick}
    >
      <div ref={modalRef} className="modal-content relative max-w-2xl">
        <button
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-800 text-3xl"
          onClick={onClose}
        >
          <IoIosClose />
        </button>
        {children}
      </div>
    </div>
  ) : null;
};

export default Modal;
